(ns frontend.view.login.select-account-and-role
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.account :as account]
   [frontend.logging :as logging]
   [frontend.utils :as fu]
   [frontend.view.login.events :as events]))

(defn role-view
  [role-entity]
  (let [{:keys [target-id tenant-id target-name target-account target-logo sso-enforced suspended?
                custom-login-path
                sandbox? ask-mfa? setup-mfa? role]}
        role-entity
        target-account-id (:db/id target-account)
        role-id (:db/id role-entity)]
    [:li
     {:class-name (fu/cs "login-roles__list-item" "clickable" (when sandbox? "sandbox-tenant"))
      :on-click   (fn []
                    (cond
                      suspended?
                      (logging/info "Cannot log into suspended tenant")
                      (and (not= :role/sys-admin role)
                           (coll? sso-enforced)
                           (some #{:azure} sso-enforced)
                           custom-login-path)
                      (do
                        (js/console.log
                         (str "Redirect to Azure login due to " (coll? sso-enforced) (some #{:azure} sso-enforced) custom-login-path))
                        (aset js/window.location
                              "href"
                              (str "/login/sso/azure/" custom-login-path)))
                      ask-mfa?
                      (events/show-mfa! target-id
                                        target-account-id
                                        role-id
                                        target-id
                                        target-name)
                      setup-mfa?
                      (events/show-mfa-setup! target-id
                                              target-account-id
                                              role-id
                                              target-id
                                              target-name)
                      :else
                      (events/set-tenant! target-id target-account-id role-id tenant-id)))}

     [:div.login-roles__list-item__body
      [:div.d-flex.align-items-center
       [:div.login-roles__list-item__body-logo
        (fu/background-image target-logo)]
       [:div
        [:span.login-roles__list-item__label (loc/tr :organization)]

        [:span
         {:class (fu/cs "login-roles__list-item__body-title"
                        (when suspended?
                          "login-roles__list-item__body-title--suspended"))}
         (str target-name
              (when suspended?
                (str " - " (loc/tr :tenant-suspended))))]]]
      [:div.login-roles__list-item__title-description
       [:span.login-roles__list-item__title-description-label (loc/tr :role) ":"]
       (loc/tr role)]]
     (str custom-login-path
          (when sso-enforced
            (->> sso-enforced
                 (map name)
                 (string/join ", "))))]))

(defn select-role-view
  [account-roles]
  [:div.login-roles-section
   [:h2.login-roles__title (loc/tr :select-environment)]
   [:ul.login-roles__list
    (doall (for [role account-roles]
             ^{:key (:db/id role)}
             [role-view role]))]])

(defn no-active-roles-view
  []
  [:div.login-roles.d-flex.flex-column.align-items-center.justify-content-center
   [:h2.login-roles__title (loc/tr :login-no-active-roles-title)]
   [:p.pt-3.pb-4.text-center (loc/tr :login-no-active-roles)]
   [:br]
   [:div
    {:id         "no-active-role-sign-out"
     :on-click   (fn [_]
                   (account/reset-session))
     :class-name (fu/cs "btn" "zap-btn__solid__salmon")}
    (loc/tr :sign-out)]])

(defn view
  [{:keys [data set-tenant! show-mfa! show-mfa-setup!]}]
  (let [{:keys [account account-roles]} data
        filtered-roles (->> account-roles
                            (remove (fn [r]
                                      (= :entity.type/workspace (:target-type r))))
                            (doall))]
    ;; only show role selection when roles have been resolved
    (if-not (nil? filtered-roles)
      (if (< (count filtered-roles) 1)
        [no-active-roles-view]
        [select-role-view filtered-roles])
      [:div.login-roles])))
